module.exports = __webpack_public_path__ + "images/27d2ab38eee9fd520820095fcda135d4-profile_overlay.jpg";